import { 
  signInWithEmailAndPassword, 
  createUserWithEmailAndPassword, 
  signOut,
  GoogleAuthProvider,
  signInWithPopup,
  User
} from 'firebase/auth';
import { auth } from '../firebase/config';
import { createUserProfile } from './utils/userProfile';
import { handleAuthError } from './utils/errors';

export async function loginWithEmail(email: string, password: string): Promise<User> {
  try {
    const { user } = await signInWithEmailAndPassword(auth, email, password);
    return user;
  } catch (error) {
    throw handleAuthError(error);
  }
}

export async function registerWithEmail(email: string, password: string, name: string): Promise<User> {
  try {
    const { user } = await createUserWithEmailAndPassword(auth, email, password);
    await createUserProfile(user, { name });
    return user;
  } catch (error) {
    throw handleAuthError(error);
  }
}

export async function loginWithGoogle(): Promise<User | null> {
  try {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({ prompt: 'select_account' });
    
    const result = await signInWithPopup(auth, provider);
    if (result.user) {
      await createUserProfile(result.user);
      return result.user;
    }
    return null;
  } catch (error) {
    throw handleAuthError(error);
  }
}

export async function logoutUser(): Promise<void> {
  try {
    await signOut(auth);
  } catch (error) {
    throw handleAuthError(error);
  }
}